import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavbarService } from '../service/navbar.service';
import { InfoService } from '../service/info.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit, OnDestroy {
  // Flag bindada em [class.is-loading] no `<main>`. Liga no `NavigationStart`
  // (clique em link/botão de rota) e desliga no `NavigationEnd|Cancel|Error`
  // (quando o novo componente está montado e renderizando). Dim representa
  // TRANSIÇÃO DE ROTA — não loading de dados internos da página, que devem
  // usar seus próprios indicadores (progress bar do topo, skeletons, etc).
  public isLoading = false;
  private routerSub?: Subscription;

  constructor(private router: Router, public navbarService: NavbarService, public infoService: InfoService) { }

  ngOnInit(): void {
    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.isLoading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.isLoading = false;
      }
      if (event instanceof NavigationEnd) {
        // a11y (WCAG 2.4.3): após cada navegação, foco vai pro <main>
        // pra que usuário de teclado/leitor de tela pule a sidebar e
        // sidebar items a cada troca de rota. `preventScroll:true` evita
        // que o foco-bring-into-view dispare scroll (já cuidamos do scroll
        // separadamente). Microtask via setTimeout(0) garante que o foco
        // acontece DEPOIS do componente novo já estar montado e renderizado.
        setTimeout(() => {
          const main = document.getElementById('main-content');
          if (main) {
            (main as HTMLElement).focus({ preventScroll: true });
          }
        }, 0);
      }
    });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }
}
